import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ current }) {
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="container-site pt-6">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm font-semibold text-plum-soft">
        <li>
          <Link to="/" data-testid="breadcrumb-home" className="transition-colors hover:text-bun-dark">
            Beranda
          </Link>
        </li>
        <li aria-hidden="true">
          <ChevronRight className="h-4 w-4" />
        </li>
        <li aria-current="page" className="text-plum">
          {current}
        </li>
      </ol>
    </nav>
  );
}
